import Images from '../utils/importImages';
export const Bio = {
  name: 'Srikanth',
  roles: ['Full Stack Developer', 'Programmer'],
  description:
    'I am a passionate Full Stack Developer building scalable web and mobile applications using modern technologies.\
  I turn complex problems into clear, efficient applications that users find easy to use and reliable.\
  And I continuously improving my skills to stay ahead in the rapidly changing tech landscape.',
  github: 'https://github.com/srikanth-rl',
  resume: 'https://drive.google.com/file/d/1uYAfIUM7-DptaD71ZtpLJMttp44MMGwH/view?usp=sharing',
  linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
  leetcode: 'https://leetcode.com/u/srikanth_rl/',
};

export const skills = [
  {
    title: 'Programming Languages',
    skills: [
      {
        name: 'Java',
        image: Images['java.svg'],
      },
      {
        name: 'Python',
        image: Images['python.svg'],
      },
      {
        name: 'C++',
        image: Images['cpp.svg'],
      },
      {
        name: 'C',
        image: Images['c.svg'],
      },

      {
        name: 'JavaScript',
        image: Images['javascript.svg'],
      },
      {
        name: 'SQL',
        image: Images['sql.svg'],
      },
      {
        name: 'Dart',
        image: Images['dart.svg'],
      },
    ],
  },
  {
    title: 'Frontend',
    skills: [
      {
        name: 'React Js',
        image: Images['reactjs.svg'],
      },
      {
        name: 'Redux',
        image: Images['redux.svg'],
      },
      {
        name: 'Next Js',
        image: Images['nextjs.svg'],
      },
      {
        name: 'HTML',
        image: Images['html5.svg'],
      },
      {
        name: 'CSS',
        image: Images['css3.svg'],
      },
      {
        name: 'Bootstrap',
        image: Images['bootstrap.svg'],
      },
      {
        name: 'Flutter',
        image: Images['flutter.svg'],
      },
    ],
  },
  {
    title: 'Backend',
    skills: [
      {
        name: 'Node Js',
        image: Images['nodejs.svg'],
      },
      {
        name: 'Express Js',
        image: Images['expressjs.svg'],
      },

      {
        name: 'Graph QL',
        image: Images['graphql.svg'],
      },

      {
        name: 'Fast API',
        image: Images['fastapi.svg'],
      },
      {
        name: 'Spring Boot',
        image: Images['spring.svg'],
      },
    ],
  },
  {
    title: 'Databases',
    skills: [
      {
        name: 'MySQL',
        image: Images['mysql.svg'],
      },
      {
        name: 'PostgreSQL',
        image: Images['postgressql.svg'],
      },
      {
        name: 'MongoDB',
        image: Images['mongodb.svg'],
      },
      {
        name: 'Firebase',
        image: Images['firebase.svg'],
      },
    ],
  },
  {
    title: 'Tools & Platforms',
    skills: [
      {
        name: 'Git',
        image: Images['git.svg'],
      },
      {
        name: 'GitHub',
        image: Images['github.svg'],
      },

      {
        name: 'VS Code',
        image: Images['vscode.svg'],
      },
      {
        name: 'Android Studio',
        image: Images['androidstudio.svg'],
      },
      {
        name: 'Postman',
        image: Images['postman.svg'],
      },
      {
        name: 'Docker',
        image: Images['docker.svg'],
      },
      {
        name: 'AWS',
        image: Images['aws.svg'],
      },
      {
        name: 'Digital Ocean',
        image: Images['digitalocean.svg'],
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: Images['thoughtscrest_logo.jpeg'],
    role: 'Associate Technical Consultant',
    company: 'Thoughtscrest Software Private Limited',
    date: 'July 2024 - December 2025',
    desc: [
      'Developed backend services for a core banking automation platform using Python (FastAPI) and PostgreSQL.',
      'Built modules for script management, advanced data preparation, and multi-database support including DB2 and Oracle.',
      'Improved system performance, scalability, and ensured strict regulatory compliance across banking workflows.',
    ],
  },
  {
    id: 0,
    img: Images['freelance.png'],
    role: 'Freelance Software Developer',
    company: 'Self-Employed',
    date: 'June 2023 - June 2024',
    desc: [
      'Developed and deployed custom web applications for clients using React, Node.js, and MongoDB.',
      'Collaborated with clients to gather requirements, design tailored solutions, and ensure timely project delivery.',
      'Built a real-time task management dashboard with live updates and analytics, implementing responsive design and performance optimization across devices and browsers.',
    ],
  },
  {
    id: 1,
    img: Images['developer.png'],
    role: 'Noobie Developer',
    company: 'Self-Learning',
    date: 'Nov 2021 - May 2023',
    desc: [
      'Learning programming languages like Java, Python and JavaScript to strengthen development fundamentals.',
      'Working on personal projects to explore new technologies and improve problem-solving skills.',
      'Building small apps to understand software architecture, version control, and deployment workflows.',
    ],
  },
];

export const projects = [
  {
    id: 0,
    title: 'Chatify',
    description:
      'Chatify is a web application designed to facilitate real-time communication and collaboration among users. It provides an user-friendly interface for seamless messaging and interaction. The application is built using React Js for the frontend, Node Js for the backend, and Firebase for data storage. It incorporates features such as user authentication, chat rooms, and message history, ensuring a secure and engaging user experience.',
    image: Images['chat.png'],
    tags: ['React Js', 'Node Js', 'Firebase'],
    category: 'web app',
    github: 'https://github.com/srikanth-rl/chat-app/',
    webapp: 'https://srikanth-chat-app.netlify.app/',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
    ],
  },
  {
    id: 1,
    title: 'Path Finder',
    description:
      'Path Finder is an interactive web application that allows users to visualize and explore various pathfinding algorithms. Built with React Js, the application provides a user-friendly interface where users can create custom grids, set start and end points, and observe how different algorithms navigate through obstacles to find the shortest path. Can also generate mazes using different maze generation algorithms. It serves as an educational tool for understanding algorithmic concepts and their practical applications in computer science.',
    image: Images['pathfinder.png'],
    tags: ['React Js', 'JavaScript', 'CSS'],
    category: 'web app',
    github: 'https://github.com/srikanth-rl/algorithm-visualizer',
    webapp: 'https://srikanth-algo-visualizer.netlify.app/#/path-finding',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
    ],
  },

  {
    id: 2,
    title: 'Currency Converter',
    category: 'android app',
    tags: ['Dart', 'Flutter', 'API'],
    description:
      'The Currency Converter is a mobile application built with Flutter, designed to provide real-time currency conversions for over 170 countries. The app integrates a live currency exchange API, handling asynchronous data requests and parsing JSON to deliver up-to-the-minute conversion rates. It features a simple and intuitive user interface, ensuring a seamless and accessible experience for users making quick currency conversions on the go.',
    image: Images['cc.png'],
    github: 'https://github.com/srikanth-rl/Currency-Converter',
    webapp: 'https://upload.app/download/currency-convertor/com.example.currency_convertor/59481797b797e6f320970f167912348755892159c14ba986b12bec4ef9c4cc8f/downloading',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
    ],
  },
  {
    id: 3,
    title: 'Sorting Visualizer',
    description:
      'Sorting Visualizer is an interactive web application that allows users to visualize and understand various sorting algorithms. Built with React Js, the application provides a user-friendly interface where users can generate random arrays and observe how different sorting algorithms, such as Bubble Sort, Merge Sort, Quick Sort, Heap Sort, etc., operate step-by-step to sort the array. It helps users grasp the concepts of sorting algorithms through visual representation and animation.',
    image: Images['sorting.png'],
    tags: ['React Js', 'JavaScript', 'CSS'],
    category: 'web app',
    github: 'https://github.com/srikanth-rl/sorting-visualizer',
    webapp: 'https://srikanth-sorting-visualizer.netlify.app/',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
    ],
  },
  {
    id: 4,
    title: 'Calculator',
    description:
      'The Calculator is a web application designed to perform a wide range of mathematical calculations through a clean and user-friendly interface. It supports all basic arithmetic operations and includes advanced functions for calculating percentages, factorials (upto 10⁵ - 1 lakh), remainders, and checking for prime numbers (upto length of 17 digits). Built for a seamless user experience, the application provides intuitive controls for clearing and deleting inputs, decimal point support for precision, and simple error handling to ensure accurate results.',
    image: Images['calculator.png'],
    tags: ['HTML', 'CSS', 'JavaScript'],
    category: 'web app',
    github: 'https://github.com/srikanth-rl/Calculator',
    webapp: 'https://srikanth-web-calculator.on.drv.tw/app/',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
    ],
  },

  {
    id: 5,
    title: 'Tic Tac Toe Bot',
    tags: ['HTML', 'CSS', 'JavaScript'],
    description: "Tic-Tac-Toe Bot is a web-based game built with p5.js that lets you challenge a computer at three different skill levels. In \"Hard\" mode, the bot uses the minimax algorithm to play perfectly, while \"Easy\" and \"Medium\" modes offer a more relaxed experience. The app includes practical features like an undo button, a scoreboard to track your win streaks, and keyboard shortcuts for quick navigation. It’s designed to be fully responsive and works directly in the browser without any heavy external dependencies.",
    image: Images['ttt.png'],

    category: 'web app',
    github: 'https://github.com/srikanth-rl/Tic-Tac-Toe-Bot',
    webapp: 'https://tic-tac-toe-bot-game.vercel.app',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
      {
        name: 'Aswin',
        img: 'https://avatars.githubusercontent.com/u/93860076',
        github: 'https://github.com/aswinsrini',
        linkedin: 'https://www.linkedin.com/in/aswin-srinivasan-dev/',
      },
    ],
  },

  {
    id: 6,
    title: 'N-Queens Visualizer',
    description:
      'N-Queens Visualizer is an interactive web application that allows users to visualize the N-Queens problem and its solutions. Built with React Js, the application provides a user-friendly interface where users can set the size of the chessboard (N) and observe how the algorithm places N queens on the board such that no two queens threaten each other. The visualizer demonstrates the backtracking algorithm used to solve the problem, providing insights into its recursive nature and decision-making process.',
    image: Images['nqueens.png'],
    tags: ['React Js', 'JavaScript', 'CSS'],
    category: 'web app',
    github: 'https://github.com/srikanth-rl/algorithm-visualizer',
    webapp: 'https://srikanth-algo-visualizer.netlify.app/#/nqueens',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
    ],
  },

  {
    id: 7,
    title: 'Dog vs Cat Classifier',
    category: 'machine learning',
    tags: ['Python', 'TensorFlow', 'Keras'],
    description:
      'The Dog vs Cat Classifier is a machine learning project, developed using Python and TensorFlow with Keras. The model is trained on a dataset of 25,000 images, achieving an impressive accuracy of 98.2% in distinguishing between dog and cat images. The project involves data preprocessing, model architecture design, and performance evaluation, showcasing the application of deep learning techniques in image classification tasks.',
    image: Images['dvc.png'],
    github: 'https://github.com/srikanth-rl/CAT-vs-DOG-ML',
    // webapp: '',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
      {
        name: 'Godwin',
        img: 'https://avatars.githubusercontent.com/u/89068702',
        github: 'https://github.com/godwin-jg',
        linkedin: 'https://www.linkedin.com/in/godwin-jg/',
      },
      {
        name: 'Aswin',
        img: 'https://avatars.githubusercontent.com/u/93860076',
        github: 'https://github.com/aswinsrini',
        linkedin: 'https://www.linkedin.com/in/aswin-srinivasan-dev/',
      },
    ],
  },

  {
    id: 8,
    title: 'Faculty Picker',
    description:
      'Faculty Picker is a web application designed to assist students in selecting their preferred faculty members for various courses. The application provides a user-friendly interface where students can browse through a list of available faculty members, view their profiles, and make informed decisions based on their qualifications and teaching styles. Built with React Js, the application ensures a seamless experience for users while incorporating features such as user authentication and personalized recommendations.',
    image: Images['facultypicker.png'],
    tags: ['React Js', 'Node Js', 'MongoDB'],
    category: 'web app',
    github: 'https://github.com/godwin-jg/Faculty-Picker',
    member: [
      {
        name: 'Srikanth',
        img: 'https://avatars.githubusercontent.com/u/98140086',
        github: 'https://github.com/srikanth-rl',
        linkedin: 'https://www.linkedin.com/in/rl-srikanth/',
      },
      {
        name: 'Godwin',
        img: 'https://avatars.githubusercontent.com/u/89068702',
        github: 'https://github.com/godwin-jg',
        linkedin: 'https://www.linkedin.com/in/godwin-jg/',
      },
    ],
  },
];

export const handleRedirect = (e, path, setIsOpen) => {
  e.preventDefault();
  if (path.startsWith('#')) {
    const element = document.getElementById(path.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  } else {
    window.location.href = path;
  }
  setIsOpen(false);
};